<template>
  <div>
    <div
        class='form'
    >
      <input
          type='email'
          class='text'
          v-model='user.email'
          placeholder="E-mailadres"
          readonly
      >

      <input
          placeholder="Nieuw wachtwoord"
          type='password'
          class='text'
          v-model='newPassword'
      >

      <ul
          class='error'
          v-if='passwordErrorMessages'
      >
        <li
            v-for='(error, index) in passwordErrorMessages'
            :key='index'
        >
          {{ error }}
        </li>
      </ul>

      <input
          placeholder="Herhaal nieuw wachtwoord"
          type='password'
          class='text'
          v-model='confirmPassword'
      >

      <button
          class='submit btn'
          @click='resetPasswordHandler'
      >
        Wachtwoord opslaan
      </button>

      <div
          class='error'
          v-if='errorMessage'
      >
        {{ errorMessage }}
      </div>

      <div
          class='success'
          v-if='successMessage'
      >
        {{ successMessage }}
      </div>
    </div>
  </div>
</template>

<script>
import {mapActions} from "vuex";
import {useRoute} from 'vue-router';

export default {
  name: "ResetPasswordForm",
  data() {
    return {
      user: {},
      token: "",
      successMessage: "",
      errorMessage: "",
      passwordErrorMessages: "",
      newPassword: "",
      confirmPassword: "",
      showForm: false,
    };
  },
  mounted() {
    this.init();
  },
  methods: {
    ...mapActions("user", [
      "resetPassword",
    ]),
    init() {
      const route = useRoute();
      const email = route.query.email;

      if (email && email.length > 0) {
        this.user.email = email;
      }
    },
    resetPasswordHandler() {
      this.errorMessage = "";
      this.passwordErrorMessages = "";
      this.successMessage = "";
      let token = this.$route.params.token;

      if (this.newPassword.length > 0 && this.confirmPassword.length > 0) {
        if (this.newPassword !== this.confirmPassword) {
          this.errorMessage = 'De nieuwe wachtwoorden komen niet overeen';
        } else if (this.newPassword.length < 8) {
          this.errorMessage = 'Het nieuwe wachtwoord moet minimaal 8 tekens lang zijn';
        } else {
          let requestData = {
            email: this.user.email,
            password: this.newPassword,
            password_confirmation: this.confirmPassword,
            token: token,
          };

          this.resetPassword(requestData)
            .then(response => {
              if (response.error) {
                this.errorMessage = response.error;
              } else {
                this.successMessage = "Wachtwoord gewijzigd. Sluit deze browser en ga verder in de app.";
              }
            })
              .catch(err => {
                if (err.response?.data?.errors?.password) {
                  this.passwordErrorMessages = err.response.data.errors.password;
                } else if (err.response?.data?.error) {
                  this.errorMessage = err.response.data.error;
                } else {
                  this.errorMessage = "Er ging iets mis. Mogelijk is de wachtwoord reset token verlopen. Vraag opnieuw een wachtwoord reset aan.";
                }
              });
        }
      } else {
        this.errorMessage = "Vul alle velden in";
      }
    },
  },
};
</script>
